import { useState } from "react";
import { Link } from "react-router-dom";
import { useProducts } from "@/hooks/useProducts";
import ProductCard from "./ProductCard";

const tabs = [
  { key: "hot", label: "體驗認購區", region: "體驗認購區" },
  { key: "new", label: "VIP認購區", region: "VIP認購區" },
];

export default function HotProducts() {
  const [activeTab, setActiveTab] = useState("hot");
  const { products, isLoading } = useProducts();

  const filtered = products.filter((p) => {
    const tab = tabs.find((t) => t.key === activeTab);
    if (tab) return p.region === tab.region;
    return true;
  });

  return (
    <section className="py-14 px-6 lg:px-12 bg-white">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">精選分銷商品</h2>
          <p className="text-gray-500 text-sm mt-1">工廠直供，高利潤空間，一件代發</p>
        </div>
        <div className="flex items-center gap-1 bg-gray-100 rounded-full p-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === tab.key
                  ? "bg-white text-amber-600 shadow-sm"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden animate-pulse">
              <div className="aspect-square bg-gray-200" />
              <div className="p-3 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4" />
                <div className="h-3 bg-gray-200 rounded w-1/2" />
                <div className="h-5 bg-gray-200 rounded w-1/3" />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {filtered.slice(0, 8).map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}

      <div className="text-center mt-8">
        <Link
          to="/products"
          className="inline-flex items-center gap-2 px-8 py-3 border border-amber-500 text-amber-600 hover:bg-amber-500 hover:text-white rounded-lg font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          查看全部商品
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </div>
        </Link>
      </div>
    </section>
  );
}